import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getEnvironment } from './utils/environment';

// ── Modo oscuro: aplica la preferencia guardada ANTES de render (sin flash).
// El estilo vive en App.css (html.dark-mode invierte la página). 2026-06-15.
try {
  if (localStorage.getItem('dark_mode') === 'true') {
    document.documentElement.classList.add('dark-mode');
  }
} catch (e) { /* localStorage no disponible */ }

// ── Sentry (error monitoring) — SOLO PRODUCCION ──────────────────────────
// DSN del proyecto FRONTEND de Sentry (clave PUBLICA de cliente; segura de
// commitear, se expone igual en el bundle). Hardcodeado porque Cloudflare
// Workers no siempre inyecta env vars de build (ver environment.js).
// 2026-06-15 (Jose): Sentry SOLO en produccion (pop.warehouse-mx.com); staging
// y dev no reportan (gate por getEnvironment), para no gastar cuota con pruebas.
const SENTRY_DSN = 'https://c55dd68e3a2e8d8643ab17c6976aa07f@o4511539021479936.ingest.us.sentry.io/4511571993690112';
if (SENTRY_DSN && getEnvironment() === 'production') {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: 'production',
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
